import { NgModule } from '@angular/core';
import { FilterPipe } from './filter.pipe';
import { FilterContactPipe } from './filter-contact.pipe';
import { FilterDetailLinePipe } from './filter-detail-line.pipe';
import { FilterDocsPipe } from './filter-docs.pipe';
import { FilterPackageSeqPipe } from './filter-package-seq.pipe';
import { FilterJobsPipe } from './filter-jobs.pipe';
import { FilterDepartmentPipe } from './filter-department.pipe';
import { FilterSerialPipe } from './filter-serial.pipe';
import { FilterSitePipe } from './filter-site.pipe';
import { FilterActionsPipe } from './filter-actions.pipe';
import { FilterDetailLineBySitePipe } from './filter-detail-line-by-site.pipe';
import { FilterBinLocationPipe } from './filter-bin-location.pipe';

@NgModule({
  declarations: [FilterPipe, FilterContactPipe,FilterBinLocationPipe, FilterDetailLinePipe, FilterDocsPipe, FilterPackageSeqPipe, FilterJobsPipe, FilterDepartmentPipe, FilterSerialPipe, FilterSitePipe, FilterActionsPipe, FilterDetailLineBySitePipe],
    exports: [FilterPipe, FilterContactPipe,FilterBinLocationPipe, FilterDetailLinePipe, FilterDocsPipe, FilterPackageSeqPipe, FilterJobsPipe, FilterDepartmentPipe, FilterSerialPipe, FilterSitePipe, FilterActionsPipe, FilterDetailLineBySitePipe]
})
export class PipesModule { }
